function Header2Desktop({ children, className }: any) {
  return <div className={`text-custom-white font-medium tracking-[0.025em] mb-4 text-[19px] ${className} `}>{children}</div>;
}

export default Header2Desktop;
